module.exports = __webpack_public_path__ + "static/img/Facebook.523442a0.jpg";